import { Injectable } from '@angular/core';
import { LoadingController, ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class WidgetsService {
  isLoading = false;

  constructor(
    private loadingController: LoadingController,
    private toastController: ToastController
  ) {}
  async toastWithButtons(message, color) {
    const toast = await this.toastController.create({
      animated: true,
      position: 'top',
      buttons: [
        {
          side: 'end',
          icon: 'close',
          handler: () => null,
        },
      ],
      color,
      cssClass: 'toast',
      duration: 2000,
      keyboardClose: true,
      message,
    });
    toast.present();
  }
  async showLoaderWithText(model = 'Jeep') {
    this.isLoading = true;
    return await this.loadingController
      .create({
        // mode: 'ios',
        spinner: null,
        // message: 'msg',
        // eslint-disable-next-line max-len
        message: `<ion-img src="assets/img/one3d-jeep-loader-new.gif"></ion-img><p class="one3d-loader-bottom-text">${model} will be yours to explore<br>In just a couple of seconds!</p>`,
        cssClass: 'one3d-jeep-loader-opaque'
      })
      .then((a) => {
        a.present().then(() => {
          if (!this.isLoading) {
            a.dismiss().then(() => {});
          }
        });
      });
  }
  async showLoader(msg = 'Please wait...') {
    this.isLoading = true;
    return await this.loadingController
    .create({
      mode: 'ios',
      spinner: 'circular',
        message: 'Please wait...',
        cssClass: 'one3d-jeep-loader'
      })
      .then((a) => {
        a.present().then(() => {
          if (!this.isLoading) {
            a.dismiss().then(() => {});
          }
        });
      });
  }
  async hideLoader() {
    this.isLoading = false;
    this.loadingController
      .getTop()
      .then((v) => (v ? this.doStopLoader() : null));
  }
  doStopLoader() {
    this.loadingController.dismiss();
  }
}
